export const apiVersion = '/osb/api/';

export const masterDataApi = {};

export const authorizationApi = {
  default: 'v3/authorize',
  logout: 'logout',
};

export const appsApi = {
  getApps: 'v3/apps',
};

export const userPreferencesApi = {
  global: 'v3/users/preferences/global',
};

export const suppliersApi = {
  search: 'v3/suppliers',
};

export const factoriesApi = {
  search: 'v3/factories',
};
